const CONSENT_KEY = "quizWebsiteConsent";
const GA_ID = "G-HRD1Y1B3YH";

// Speichert Consent-Objekt mit Timestamp + Version (DSGVO-Nachweis nach Art. 7 Abs. 1)
// Hinweis: localStorage gilt nach § 25 TDDDG als Endgerätezugriff –
// die Nutzung für den Consent selbst ist als technisch notwendig zulässig,
// muss aber in der Datenschutzerklärung erwähnt werden.
export const setConsent = (value) => {
    const consentData = {
        status: value,        // "accepted" | "declined"
        timestamp: new Date().toISOString(),
        version: "1.0",
    };
    localStorage.setItem(CONSENT_KEY, JSON.stringify(consentData));
};

// Gibt das rohe Objekt zurück (oder null wenn noch nie gesetzt)
export const getConsentData = () => {
    try {
        const raw = localStorage.getItem(CONSENT_KEY);
        if (!raw) return null;
        return JSON.parse(raw);
    } catch {
        return null;
    }
};

// Gibt "accepted" | "declined" | null zurück
export const getConsent = () => {
    const data = getConsentData();
    return data ? data.status : null;
};

// Wurde der Consent-Dialog überhaupt schon einmal beantwortet?
export const hasConsentBeenSet = () => {
    return getConsent() !== null;
};

// Hat der User Analytics akzeptiert?
export const hasAnalyticsConsent = () => {
    return getConsent() === "accepted";
};

// Widerruf: setzt Consent auf "declined" UND löscht vorhandene GA-Cookies
export const revokeConsent = () => {
    setConsent("declined");

    // GA blockieren (verhindert neues Tracking)
    window[`ga-disable-${GA_ID}`] = true;

    // Bestehende GA-Cookies aus dem Browser löschen
    const cookiesToDelete = [
        "_ga",
        "_gid",
        "_gat",
        `_ga_${GA_ID.replace("G-", "")}`,
    ];
    const domain = window.location.hostname;

    cookiesToDelete.forEach((name) => {
        document.cookie = `${name}=; Max-Age=0; path=/; domain=${domain}`;
        document.cookie = `${name}=; Max-Age=0; path=/; domain=.${domain}`;
        document.cookie = `${name}=; Max-Age=0; path=/`;
    });
};